import styled from '@emotion/styled';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { CircularRates } from 'src/shared/components/CircularRates';
import { color, font } from 'src/shared/styles/variables';

import { changeSingleValueQuestionAnswer } from '../actions/surveysActions';
import { QuestionComponentBaseProps, SurveyRateQuestionAnswer } from '../models/surveys';
import { getProgramSurveySingleQuestionAnswer } from '../selectors/surveysSelectors';
import { QuestionHeader } from './QuestionHeader';

const RangesDescriptions = styled('p')(
    {
        marginTop: '0.88rem',
        color: color.mamba,
        fontStyle: 'italic',
    },
    font.book(font.size.base),
);

interface StateProps {
    answer: SurveyRateQuestionAnswer | undefined;
}

interface ActionsProps {
    changeSingleValueQuestionAnswer: typeof changeSingleValueQuestionAnswer;
}

interface Props extends QuestionComponentBaseProps, StateProps, ActionsProps {
    range: number;
    minLabel: string;
    maxLabel: string;
    minMaxDescriptions?: string[];
}

export class RateQuestionContainer extends React.PureComponent<Props> {
    public handleRateChange = (value: number) => {
        const { programId, surveyId, id } = this.props;

        this.props.changeSingleValueQuestionAnswer({
            programId,
            surveyId,
            question: id,
            value,
        });
    };

    public render(): JSX.Element {
        const {
            question,
            range,
            minLabel,
            maxLabel,
            minMaxDescriptions,
            answer,
            readableIndex,
        } = this.props;

        const shouldRenderDescriptions = minMaxDescriptions && !isEmpty(minMaxDescriptions);

        return (
            <>
                {question && <QuestionHeader index={readableIndex} header={question} />}
                <CircularRates
                    range={range}
                    currentRate={answer && answer.data.content}
                    onRateChange={this.handleRateChange}
                    minLabel={minLabel}
                    maxLabel={maxLabel}
                />
                {shouldRenderDescriptions && (
                    <RangesDescriptions>
                        {minMaxDescriptions!.map(description => (
                            <React.Fragment key={description}>
                                {description}
                                <br />
                            </React.Fragment>
                        ))}
                    </RangesDescriptions>
                )}
            </>
        );
    }
}

const mapStateToProps = (state: AppState, { programId, surveyId, id }: Props): StateProps => ({
    // TODO: Create generic selector typing
    answer: getProgramSurveySingleQuestionAnswer(state, programId, surveyId, id) as
        | SurveyRateQuestionAnswer
        | undefined,
});

export const RateQuestion = connect(mapStateToProps, {
    changeSingleValueQuestionAnswer,
})(RateQuestionContainer);
